<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <!--<Button class="add_item" icon="md-add" type="primary" ghost @click="addCustomerStatus = true">新增</Button>-->
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <!--<Input class="search-ipt" type="text" v-model="searchIpt.keyword" placeholder="请输入用户名或手机号" clearable/>-->
            <!--<Button type="primary" icon="md-search" class="search_tn" data-level="common" @click="getVideoList">搜索</Button>-->
            <Button type="success" icon="md-thumbs-up" class="search_tn" data-level="common" :disabled="canFlag" @click="approvalVideo(1)">通过</Button>
            <Button type="error" icon="md-thumbs-down" class="search_tn" data-level="common" :disabled="canFlag" @click="approvalVideo(2)">拒绝</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData" @on-selection-change="selectionChange">
        <template slot-scope="{ row }" slot="name">
          <div class="name_wrapper">
            <img class="video_icon" :src="url + row.icon" alt="">
            <span class="video_name">{{row.name}}</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a class="jump_color" @click="playVideo(row)">查看</a>
          <a class="jump_color" @click="approvalVideo(1,row.id)">通过</a>
          <a class="jump_color" @click="approvalVideo(2,row.id)">拒绝</a>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getVideoList"></paging>
    <Modal v-model="videoPlayFlag" width="992" :closable="false" :mask-closable="false">
      <div class="modal-div">
        <video class="video" :src="videoUrl" controls controlsList="nodownload" width="960" autoplay ref="video"></video>
      </div>
      <div class="custom_footer" slot="footer">
        <Button @click="hideVideoModal">取消</Button>
        <Button type="warning" @click="approvalVideo(2)">拒绝</Button>
        <Button type="success" @click="approvalVideo(1)">通过</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import global from '../common/Global';
  import {messageAlert, dealDate,alertTips} from "../common/common";
  import {_getVideoList,_approvalVideo} from '../api/api';
  import paging from '../templates/Paging';

  export default {
    name: "VideoFilter",
    components:{paging},
    data() {
      return {
        tableHeader: [
          {
            type:'selection',
            width: 60,
            align:'center'
          },
          {
            title: "文件名",
            key: "name",
            align: "center",
            slot:'name'
          },
          {
            title: "文件大小",
            key: "size",
            align: "center",
          },
          {
            title: "上传者",
            key: "uploader",
            align: "center"
          },
          {
            title: "上传时间",
            key: "time",
            align: "center"
          },
          {
            title: "操作",
            key: "action",
            slot: "action",
            align: "center",
            width: 180
          }
        ],
        tableData: [],
        searchIpt: {
          keyword: ''
        },
        totalNum: 0,
        pageSize:9,
        url:global.fileUrl,
        selectVideo:[],
        videoUrl:'',
        videoPlayFlag:false,
      }
    },
    computed:{
      canFlag:function () {
        return !this.selectVideo.length ;
      }
    },
    methods: {
      hideVideoModal(){
        this.videoUrl = '';
        this.selectVideo = [];
        this.videoPlayFlag = false;
      },
      selectionChange(msg){
        if(msg.length) {
          this.selectVideo = msg.map(item => {return item.id})
        }else {
          this.selectVideo =[];
        }
      },
      getVideoList(msg) {
        let params = {
          page: typeof msg === "object" && msg.pageNum ? msg.pageNum - 1 : 0,
          size: this.pageSize
        };
        _getVideoList({params:params}).then(res => {
          if (res.code == 0) {
            res.data.content.length &&
            res.data.content.forEach(item => {
              item.time = dealDate(item.createTime);
              // 文件大小的转换
              if (Math.floor(item.size / 1024) >= 1 &&Math.floor(item.size / 1024 / 1024) < 1) {
                item.size = (item.size / 1024).toFixed(2) + "KB";
              } else if (Math.floor(item.size / 1024) < 1) {
                item.size = item.size + "B";
              } else if (Math.floor(item.size / 1024 / 1024) >= 1) {
                item.size = (item.size / 1024 / 1024).toFixed(2) + "MB";
              }
            });
            this.totalNum = res.data.total;
            this.tableData = res.data.content
          } else {
            messageAlert(res.message)
          }
        })
      },
      approvalVideo(flag,id){
        let listId =id || this.selectVideo.join(',');
        _approvalVideo(listId,flag).then(res => {
          if(res.code == 0) {
            alertTips('success','操作成功');
            this.selectVideo = [];
            this.videoUrl = '';
            this.videoPlayFlag = false;
            this.getVideoList();
          }else {
            messageAlert(res.message)
          }
        })
      },
      playVideo(row){
        this.$refs.video['disablePictureInPicture'] = true;
        this.videoUrl = global.fileUrl + row.path;
        this.selectVideo = [row.id];
        this.videoPlayFlag = true;
      },
    },
    mounted() {
      this.getVideoList();
    }
  }
</script>

<style scoped>
  .name_wrapper{
    display: flex;
    align-items: center;
  }
  .name_wrapper .video_icon{
    width: 60px;
    height: 60px;
    margin: 10px;
  }
  .name_wrapper .video_name{

  }
  .video{

  }
</style>



// WEBPACK FOOTER //
// src/components/VideoFilter.vue